import styled from 'styled-components';

const TablePageSizer = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: auto auto 1fr;
  grid-column-gap: ${(props): string => props.theme.spaces.xl};

  > div {
    display: flex;
    align-items: center;
  }
`;

export { TablePageSizer };
